// extracted by mini-css-extract-plugin
export var deleteModal = "_hc-0";